<p-dialog
  [visible]="localVisible()"
  (visibleChange)="onVisibilityChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ width: '58vw', height: '100vh' }"
  [styleClass]="'docx-viewer-dialog'"
  [maskStyleClass]="'docx-viewer-dialog-mask'"
  [position]="'right'"
  [baseZIndex]="10000"
  [header]="data()?.title || data()?.filename || 'Document Viewer'"
  (onHide)="onClose()"
  (onShow)="onShow()">

  <div class="docx-viewer-content">
    @if (loading()) {
      <div class="flex justify-content-center align-items-center h-full">
        <p-progressspinner></p-progressspinner>
      </div>
    }

    @if (error()) {
      <div class="flex flex-column justify-content-center align-items-center h-full text-center">
        <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
        <h3>Unable to load document</h3>
        <p class="text-color-secondary">{{ error() }}</p>
      </div>
    }

    <!-- Always render the container but hide it when loading or error -->
    <div #docxContainer
         class="docx-container"
         [style.display]="loading() || error() ? 'none' : 'block'">
    </div>
  </div>
</p-dialog>